import { Plugin, DataFilter } from "ckeditor5";

import { createConversions } from "./conversions";
import { createMenu } from "./menu";

export type TableStyleDefinition = {
  name: string;
  classes: string[];
};

export default class TableStylesPlugin extends Plugin {
  public static get requires() {
    return [DataFilter];
  }

  init() {
    const config = this.editor.config.get("tableStyles");
    if (config?.definitions == null) return;

    this.editor.model.schema.extend("table", {
      allowAttributes: "tableClass",
    });

    const keyedDefinitions = Object.fromEntries(
      config.definitions.map((d) => [d.name, d]),
    );

    createConversions(this.editor, keyedDefinitions);

    createMenu(this.editor, keyedDefinitions);
  }
}

declare module "ckeditor5" {
  interface EditorConfig {
    tableStyles?: {
      definitions?: TableStyleDefinition[];
    };
  }
}
